import { useState } from 'react';
import { Alert } from 'react-bootstrap';
import useCoachPerformanceReport from '@nkr/store/microsites/hooks/use-coach-performance-report';
import Filter from './filter';
import PerformanceGrid from './performance-grid';
import { styles } from './styles';

interface IOwnProps {
    isSuperAdmin: boolean;
}

const MicrositeCoachPerformance = ({ isSuperAdmin }: IOwnProps) => {
    const [year, setYear] = useState<number>(new Date().getFullYear());
    const [coachId, setCoachId] = useState<number>(0);

    const { data, loading, error, exportData } = useCoachPerformanceReport(isSuperAdmin, year, coachId);

    const handleExport = () => exportData();

    return (
        <div className='container-fluid'>
            <h3>{isSuperAdmin ? 'Microsite Coach Performance Report' : 'Your Performance Report'}</h3>

            <Filter
                year={year}
                coachId={coachId}
                isSuperAdmin={isSuperAdmin}
                onYearChange={setYear}
                onCoachChange={setCoachId}
                onExport={handleExport}
            />

            {loading && (
                <div style={styles.alertWrapper}>
                    <Alert bsStyle='info'>Loading report data...</Alert>
                </div>
            )}

            {!loading && error && (
                <div style={styles.alertWrapper}>
                    <Alert bsStyle='danger'>{error}</Alert>
                </div>
            )}

            {!loading && !error && data && data.length === 0 && (
                <div style={styles.alertWrapper}>
                    <Alert bsStyle='info'>No data available for the selected filters.</Alert>
                </div>
            )}

            {!loading && !error && data && data.length > 0 && (
                <PerformanceGrid
                    data={data}
                    isSuperAdmin={isSuperAdmin}
                    year={year}
                    coachId={coachId}
                />
            )}
        </div>
    );
};

export default MicrositeCoachPerformance;
